import React, { useMemo } from 'react';
import { Box, ElectionAmount, FlexListHeader, Inscription, ListItemBase } from '@common-fe/common-fe';
import { uniqueId } from 'lodash';
import styled from 'styled-components';

import { NON_ASSIGNABLE_VALUE } from '@/common/constants';
import { formatCurrency } from '@/utils';

const Wrapper = styled(Box)`
  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacings.spacing4};
  }
`;

const ElectionAmountTable: React.FC<{
  electionPeriods: ElectionAmount[];
}> = ({ electionPeriods }) => {
  const headers: ListItemBase[] = useMemo(() => {
    const currentHeaders = [
      {
        key: 'period',
        title: 'Period',
        flex: '3',
      },
      {
        key: 'amount',
        title: 'Election Amount',
        flex: '2',
      },
    ];
    return currentHeaders;
  }, []);

  const sortedElectionPeriods = useMemo(() => {
    return electionPeriods.sort(
      (a, b) => new Date(b?.validFrom || 0).getTime() - new Date(a?.validFrom || 0).getTime()
    );
  }, [electionPeriods]);

  return (
    <Box data-testId="election_amount_table" background="module" pad="xs" round="small">
      <FlexListHeader items={headers} thinMode />
      {sortedElectionPeriods.map((item, index) => (
        <Wrapper
          key={uniqueId()}
          height="36px"
          background="canvas"
          border={{ color: 'border2' }}
          round="dropdownItemRound"
          margin={{ top: index === 0 ? 'spacing4' : '0px' }}
          pad={{ vertical: 'spacing8', horizontal: 'spacing24' }}
          direction="row"
          align="center"
          data-testid={`election-amount-row-${index}`}
        >
          <Box
            height="24px"
            direction="row"
            align="center"
            width="60%"
            data-testid={`election-amount-row-${index}_period`}
          >
            <Inscription
              size="small"
              lineHeight="18px"
              style={{ fontWeight: 500 }}
              data-testid={`election-amount-row-${index}_period-start`}
            >
              {item.validFrom}
            </Inscription>
            &nbsp;-&nbsp;
            <Inscription
              size="small"
              lineHeight="18px"
              style={{ fontWeight: 500 }}
              data-testid={`election-amount-row-${index}_period-end`}
            >
              {item.validTo}
            </Inscription>
          </Box>

          <Box height="24px" direction="row" align="center" width="40%">
            <Inscription
              size="small"
              lineHeight="18px"
              style={{ fontWeight: 500 }}
              data-testid={`election-amount-row-${index}_election-amount`}
            >
              {item.amount !== null ? formatCurrency(item.amount) : NON_ASSIGNABLE_VALUE}
            </Inscription>
          </Box>
        </Wrapper>
      ))}
    </Box>
  );
};

export default ElectionAmountTable;
